import React, { useEffect } from 'react';

const SplashScreen = ({ onFinish }) => {

    useEffect(() => {
        const timer = setTimeout(() => {
            onFinish();
            // _uiUpdate()
        }, 2500);
        return () => clearTimeout(timer);
    }, [onFinish]);

    // const _uiUpdate = () => {
    //     const splashElements = document.getElementsByClassName('splash-screen');
    //     if (splashElements.length > 0) {
    //         const splash = splashElements[0];
    //         // splash.style.width = "100%";
    //         // splash.style.height = "40px";
    //         // // splash.style.top = "0";
    //         // splash.style.marginTop = "5%"
    //         // splash.style.position = "relative important";
    //         // splash.style.overflow="auto !important";
    //     }
    // }

    return (
        <div className="splash-screen">
            <div className="zoom-background rounded-circle"></div>
            <div className='d-flex align-items-center justify-content-center'>
                <div className="logo-scale ">
                    <div className='d-flex align-items-center '>
                        <img src={require("../../Assets/logo-fixed.svg").default}
                            width={200}
                            // height={200}
                            draggable={false}
                            alt="Tranna logo"
                        />

                        <h3 className='mb-0 e-check  e-primary-font '>
                            Check
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SplashScreen;
